export default __webpack_public_path__ + "static/media/synest-hesia.728e74a2.png";